import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const SITE_URL = import.meta.env.VITE_SITE_URL;

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  'name': 'Disclaimer - CSSBuySpreadsheet.asia',
  'description': 'Disclaimer do CSSBuySpreadsheet.asia. Aviso legal sobre o conteúdo do melhor CSSBuy Spreadsheet 2026.',
  'url': `${SITE_URL}/disclaimer`,
  'inLanguage': 'pt',
  'isPartOf': {
    '@type': 'WebSite',
    'name': 'CSSBuy Spreadsheet',
    'url': SITE_URL,
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  'itemListElement': [
    {
      '@type': 'ListItem',
      'position': 1,
      'name': 'CSSBuy Spreadsheet',
      'item': SITE_URL,
    },
    {
      '@type': 'ListItem',
      'position': 2,
      'name': 'Disclaimer',
      'item': `${SITE_URL}/disclaimer`,
    },
  ],
};

export default function Disclaimer() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <JsonLd data={webPageSchema} />
      <JsonLd data={breadcrumbSchema} />
      <Navbar />
      <main>
        <article className="w-full pt-24 pb-14 md:pt-28 md:pb-20">
          <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
            <div className="mb-8">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200"
              >
                <i className="ri-arrow-left-line text-base"></i>
                Voltar ao Início
              </Link>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-8">
              Disclaimer
            </h1>

            <div className="space-y-5 text-foreground-700 leading-relaxed text-sm md:text-base">
              <h2 className="font-heading text-xl font-semibold text-foreground-950 mt-6 mb-3">Aviso Importante</h2>
              <p>
                O <strong>CSSBuySpreadsheet.asia</strong> é um site informativo independente. Não somos 
                afiliados, patrocinados ou oficialmente conectados ao CSSBuy ou qualquer uma de suas 
                plataformas associadas.
              </p>
              <p>
                Todo o conteúdo relacionado ao <strong>CSSBuy Spreadsheet</strong> é fornecido apenas para 
                fins informativos e educacionais. As informações sobre produtos, preços, vendedores e 
                métodos de envio são baseadas em experiências da comunidade e podem não refletir as 
                condições atuais do mercado.
              </p>
              <p>
                O <strong>CSSBuy Spreadsheet 2026</strong> que apresentamos é uma compilação de recomendações 
                da comunidade. Não garantimos a qualidade, autenticidade ou disponibilidade de qualquer 
                produto listado. Recomendamos que os usuários realizem sua própria pesquisa e verificação 
                antes de efetuar qualquer compra.
              </p>
              <p>
                Os links para o site principal do <strong>CSSBuy Sheet</strong> e outras plataformas são 
                fornecidos como referência. Não nos responsabilizamos por transações realizadas em sites 
                de terceiros. Todas as compras devem ser feitas com a devida cautela e dentro das políticas 
                de cada plataforma.
              </p>
              <p>
                Para mais informações, consulte nossos 
                <Link to="/termos" className="text-primary-600 hover:text-primary-700 underline"> Termos de Uso</Link> e 
                <Link to="/politica-privacidade" className="text-primary-600 hover:text-primary-700 underline"> Política de Privacidade</Link>.
              </p>

              <p className="text-xs text-foreground-500 mt-8">
                Última atualização: Junho de 2026
              </p>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}